import { render, staticRenderFns } from "./callScript.vue?vue&type=template&id=651762c5"
import script from "./callScript.vue?vue&type=script&lang=js"
export * from "./callScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports